import { cn } from '@/utils';
import { memo } from 'react';

import Modal from '../common/modal';
import { useLogic } from './appraisal-info-popup.logic';
import { TAppraisalInfoPopupProps } from './appraisal-info-popup.type';

const AppraisalInfoPopup = ({
	title = '평가 정보',
	className,
	...props
}: TAppraisalInfoPopupProps) => {
	const { appraisalInfoList } = useLogic(props);

	return (
		<Modal
			title={title}
			classNames={{ body: '!p-0', footer: '!m-0' }}
			className={cn('!w-[459px]', className)}
			labelButton="확인"
			classNameBtnContainer="mt-0 pb-2.5"
			onClickButton={props.onCancel}
			destroyOnClose
			{...props}
		>
			<div className="flex flex-col gap-2.5 p-2.5">
				{appraisalInfoList.map((item) => (
					<div
						key={item.key}
						className={cn(
							'row-between gap-2 text-[13px] text-font2',
							item?.className
						)}
					>
						<div>{item.label}</div>
						<div>
							{typeof item.value === 'number' ? `${item.value}점` : item.value}
						</div>
					</div>
				))}
			</div>
		</Modal>
	);
};

export default memo(AppraisalInfoPopup);
